
export default
function LoadingBox() {
	return <p>Loading...</p>
}
